import { TermsAndConditionsService } from 'root/platform/services';
import { AuthService } from './../../../services/auth-service/auth.service';
import { Subscription } from 'rxjs';
import { BroadcastService,FrontendContextService} from 'root/services';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { TermsAndConditionsTypes } from 'root/platform/components/legal/terms-and-conditions/terms-and-conditions.enum';
import { Router } from '@angular/router';
import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { EcommerceRouterLinkDirective } from 'root/directives/ecommerce-router-link/ecommerce-router-link.directive';
import { environment } from 'root/environment';
import { UserStatus } from 'root/mibp-openapi-gen/models';
import { GlobalConfigService } from 'root/services/global-config/global-config.service';
import { MySandvikFeatures } from 'root/services/permission';


@Component({
  selector: 'mibp-footer-v2',
  templateUrl: './footer-v2.component.html',
  styleUrls: ['./footer-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, EcommerceRouterLinkDirective]
})
export class MibpFooterV2Component implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  private broadcast = inject(BroadcastService);
  private termsAndConditions = inject(TermsAndConditionsService);
  private frontEndContext = inject(FrontendContextService);
  private router = inject(Router);
  private globalConfig = inject(GlobalConfigService);
  
  lang: string;
  langSub: Subscription;
  mibpSessionSub: Subscription;
  digitalTermsUrl: string;
  isLoggedIn = false;
  isInteroperabilityPolicyEnabled = false;

  ngOnInit(): void {
    this.lang = this.broadcast.snapshot.language;
    this.langSub = this.broadcast.language.subscribe(langCode => this.lang = langCode);
    this.mibpSessionSub = this.broadcast.mibpSession.subscribe(() => this.isLoggedIn = this.auth.isLoggedIn());
    this.digitalTermsUrl = this.globalConfig.digitalTermsUrl;
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
    this.mibpSessionSub?.unsubscribe();
  }

  logout(): void {
    this.auth.signout();
  }

  showTermsAndConditions(): void {
    this.termsAndConditions.showTermsAndConditions(TermsAndConditionsTypes.General, true);
  }

  gotoContactUs(e: Event): void {
    e.preventDefault();

    const canUseContactUsForm = this.frontEndContext.testPermission({
      features: [MySandvikFeatures.ContactUsForm],
    });

    if (this.isLoggedIn && canUseContactUsForm) {
      const userStatus = this.broadcast.snapshot.mibpSession?.user?.status;
      const externalStatuses = [
        UserStatus.Suspended,
        UserStatus.Inactivated,
        UserStatus.New,
        UserStatus.Rejected
      ];
      const shouldUseExternalContactUrl = externalStatuses.includes(userStatus);

      if (!shouldUseExternalContactUrl) {
        this.router.navigateByUrl(
          this.frontEndContext.Navigation.ensureUrlLanguage('/support/contact'));
        return;
      }
    }

    window.location.href = environment.contactUsUrl;
  }
}
